import { TiltLatestSiteData } from 'src/app/shared/interfaces/latest-site-data';

import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-site-detail-tilt-sensor',
  templateUrl: './site-detail-tilt-sensor.component.html',
  styleUrls: ['./site-detail-tilt-sensor.component.scss'],
})
export class SiteDetailTiltSensorComponent {
  @Input() tiltData: TiltLatestSiteData | null = null;
}
